import React from 'react';
import { default as useMediaQuery } from "@pb/utils/reactHooks/useMediaQuery";
import { Breakpoints } from "@pb/utils/constants/breakpoints";
import cn from 'classnames';
import { IconButton } from "../../../CTA";
import CloseIcon from "../../../Icon/HmIcons/CloseIcon";
import HeadingMedium from "../../../Typography/titles/HeadingMedium";
import styles from './ModalTitle.module.scss';
const ModalTitle = ({ closeButtonText, closeButtonClassName, modalHeadingClassName, modalTitleClassName, title, isPersistent, toggleModal, onCloseButtonClick = () => { }, customTitle, isLargeModalPadding = false, isModalCompressed = false, closeIconSize, headingAlignment, closeIconStyle = 'default', }) => {
    const isLargeScreen = useMediaQuery(Breakpoints.LARGE);
    const onClose = () => {
        toggleModal(false);
        onCloseButtonClick();
    };
    const handleModalClose = (event) => {
        if (event.key === 'Enter') {
            onClose();
        }
    };
    if (!customTitle && !title) {
        if (isPersistent) {
            return null;
        }
        return (React.createElement("div", { className: cn(styles.heading, styles.closeButtonContainer, modalHeadingClassName, closeButtonClassName, modalTitleClassName, headingAlignment, isModalCompressed && styles.compressedModal) },
            React.createElement(IconButton, { className: cn(isLargeModalPadding ? styles.largeModalPaddingCloseButton : styles.closeButton, closeButtonClassName), onClick: onClose, onKeyDown: handleModalClose, title: closeButtonText, iconElement: React.createElement(CloseIcon, { size: closeIconStyle === 'defined'
                        ? closeIconSize
                        : isLargeScreen || isModalCompressed
                            ? 'small'
                            : 'normal' }) }, closeButtonText)));
    }
    return (React.createElement("header", { className: cn(styles.heading, modalHeadingClassName, headingAlignment && styles[headingAlignment]) },
        !customTitle && title && (React.createElement(HeadingMedium, { Tag: "h2", marginless: true, horizontalAlignment: headingAlignment, className: cn(styles.modalTitle, modalTitleClassName) }, title)),
        customTitle,
        !isPersistent && (React.createElement(IconButton, { className: cn(isLargeModalPadding ? styles.largeModalPaddingCloseButton : styles.closeButton, closeButtonClassName), onClick: onClose, onKeyDown: handleModalClose, title: closeButtonText, iconElement: React.createElement(CloseIcon, { size: closeIconStyle === 'defined'
                    ? closeIconSize
                    : isLargeScreen || isModalCompressed
                        ? 'small'
                        : 'normal' }) }, closeButtonText))));
};
export default ModalTitle;
//# sourceMappingURL=ModalTitle.js.map